module.exports = __webpack_public_path__ + "img/jiancesqing.3a88cf8a.svg";